/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lump Sum Calculator`)
};

const es_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Suma Única`)
};

const de_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pauschalanlage-Rechner`)
};

const nl_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eenmalige beleggingscalculator`)
};

const fr_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculatrice Versement Unique`)
};

const it_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore Investimento Forfettario`)
};

const pt_br2_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Investimento Único`)
};

const pt_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de Montante Único`)
};

const ja_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一括投資計算機`)
};

const zh_sip_lumpsum_h1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一次性投资计算器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sip_lumpsum_h1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sip_lumpsum_h1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sip_lumpsum_h1", locale)
	if (locale === "en") return en_sip_lumpsum_h1(inputs)
	if (locale === "es") return es_sip_lumpsum_h1(inputs)
	if (locale === "de") return de_sip_lumpsum_h1(inputs)
	if (locale === "nl") return nl_sip_lumpsum_h1(inputs)
	if (locale === "fr") return fr_sip_lumpsum_h1(inputs)
	if (locale === "it") return it_sip_lumpsum_h1(inputs)
	if (locale === "pt-BR") return pt_br2_sip_lumpsum_h1(inputs)
	if (locale === "pt") return pt_sip_lumpsum_h1(inputs)
	if (locale === "ja") return ja_sip_lumpsum_h1(inputs)
	return zh_sip_lumpsum_h1(inputs)
};